import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";

import { ChatApiFactory } from "@/apis/chat";
import { SocketProvider, useSetupGlobalEvents } from "@/context/socket";
import { ChatSession as IChatSession } from "@/schema/chat";

import { AgentChatSession } from "@/components/chat/session";
import { ResponsiveMain } from "@/components/layout/main";
import { ProtectedLayout } from "@/components/layout/protected";
import { ResponsiveSidebar } from "@/components/layout/sidebar";

export const Route = createFileRoute("/dashboard/chat/$session")({
  loader: async ({ params }) => ChatApiFactory.Apis.FetchChatSession(params.session),
  validateSearch: z.object({ tool: z.string().optional() }),
  component: RouteComponent,
  staleTime: 0,
  gcTime: 0,
});

function RouteComponent() {
  const data = Route.useLoaderData();
  const params = Route.useSearch();

  useSetupGlobalEvents();

  return (
    <ProtectedLayout mode="dashboard">
      <SocketProvider>
        <ResponsiveSidebar />
        <ResponsiveMain>
          <ChatSession key={data.id} data={data} tool={params.tool} />
        </ResponsiveMain>
      </SocketProvider>
    </ProtectedLayout>
  );
}

interface ChatSessionProps {
  data: IChatSession;
  tool?: string;
}

function ChatSession({ data, tool }: ChatSessionProps) {
  return <AgentChatSession key={data.id} data={data} tool={tool} visibility="private" />;
}
